import { createContext, type RefObject, useContext } from "react";

const ThemeContainerContext = createContext<RefObject<HTMLDivElement | null>>({ current: null });

export const useThemeContainer = (): HTMLDivElement | null => useContext(ThemeContainerContext).current;

export { ThemeContainerContext };
